import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer-visits-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "card-body p-4" }, [
      _createElementVNode("div", { class: "trezo-card-header d-flex align-items-center justify-content-between" }, [
        _createElementVNode("div", { class: "trezo-card-title" }, [
          _createElementVNode("h5", { class: "mb-0" }, "Customer Visits")
        ])
      ]),
      _createElementVNode("div", { class: "trezo-card-content" }, [
        _createElementVNode("div", { class: "content position-relative z-1 d-flex justify-content-between" }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", { class: "icon rounded-circle d-flex align-items-center justify-content-center" }, [
              _createElementVNode("i", { class: "ri-user-fill" })
            ]),
            _createElementVNode("span", { class: "sub-title d-block" }, " Walk-In Customers "),
            _createElementVNode("h3", null, "1.5K"),
            _createElementVNode("span", { class: "trezo-badge shipped" }, " +7% ")
          ]),
          _createElementVNode("div", { class: "text-end" }, [
            _createElementVNode("div", { class: "icon ms-auto rounded-circle d-flex align-items-center justify-content-center" }, [
              _createElementVNode("i", { class: "ri-user-add-fill" })
            ]),
            _createElementVNode("span", { class: "sub-title d-block" }, " Repeat Customers "),
            _createElementVNode("h3", null, "2.1K"),
            _createElementVNode("span", { class: "trezo-badge cancelled" }, " -1.4% ")
          ]),
          _createElementVNode("div", { class: "light text-primary rounded-circle d-flex align-items-center justify-content-center" }, [
            _createElementVNode("i", { class: "ri-flashlight-line" })
          ])
        ]),
        _createElementVNode("div", {
          class: "progress trezo-progress bg-success w-100",
          role: "progressbar",
          "aria-valuenow": "32",
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, [
          _createElementVNode("div", {
            class: "progress-bar bg-primary",
            style: {"width":"32%"}
          })
        ]),
        _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
          _createElementVNode("span", { class: "d-block text-xs" }, " 32% "),
          _createElementVNode("span", { class: "d-block text-xs" }, " 64% ")
        ])
      ])
    ], -1)
  ]))]))
}